import React from 'react'
import { Link } from 'react-router-dom'
import ModalUI from '../../../widgets/layout/ModalUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const TestLoanCloneCreateModalUI = ({ context, successMsg, errorList, setErrorList, accountList,
    // modes
    updateMode, submitted, loan,
    // event handlers
    onSubmit, onCancelClick,
    // form fields
    accountId, onAccountIdChange, accountIdError, setAccountIdError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Select Account'
        buttonLabel='Clone'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputSelectSF type='select' name='Account Id' label='Account'
            value={accountId} onChange={onAccountIdChange} optionList={accountList}
            error={accountIdError} setError={setAccountIdError}
        />
    </ModalFormUI>

export default TestLoanCloneCreateModalUI